'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { compareLink } from '@/lib/compareLink';
import { urlForCmsLink } from '@/lib/urlForCmsLink';
import type { CmsLink } from '@/services/cms/models/CmsLink';
export type MobileDrawerProps = {
  navigation: CmsLink[];
  activePageSlug?: string;
};
export default function MobileDrawer(t0) {
  const $ = _c(15);
  const {
    navigation,
    activePageSlug
  } = t0;
  const [open, setOpen] = React.useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function toggleDrawer() {
      setOpen(_temp);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const toggleDrawer = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = function closeDrawer() {
      setOpen(false);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const closeDrawer = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <IconButton size="large" aria-label="Main navigation" aria-controls="menu-appbar" aria-haspopup="true" onClick={toggleDrawer} color="inherit"><MenuIcon /></IconButton>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      paper: {
        sx: {
          top: {
            xs: "57px",
            sm: "65px"
          },
          display: {
            xs: "block",
            md: "none"
          }
        }
      },
      backdrop: {
        invisible: true
      }
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      width: 250
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== activePageSlug || $[6] !== navigation) {
    let t7;
    if ($[8] !== activePageSlug) {
      t7 = link => {
        const url = urlForCmsLink(link.url);
        const active = compareLink(url, activePageSlug, true);
        return <ListItem key={`nav-item-${link.id}`} disablePadding={true}><ListItemButton selected={active} component={Link} href={url} aria-current={active ? "page" : undefined}><ListItemText primary={link.title} /></ListItemButton></ListItem>;
      };
      $[8] = activePageSlug;
      $[9] = t7;
    } else {
      t7 = $[9];
    }
    t6 = navigation.map(t7);
    $[5] = activePageSlug;
    $[6] = navigation;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = <Box sx={t5} role="presentation" onClick={closeDrawer}><List>{t6}</List></Box>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== open || $[13] !== t7) {
    t8 = <>{t3}<Drawer open={open} onClose={closeDrawer} slotProps={t4}>{t7}</Drawer></>;
    $[12] = open;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}
function _temp(prevState) {
  return !prevState;
}